import { JSXElementConstructor } from 'react'

export const composeComponents = (components: JSXElementConstructor<any>[]) =>
  components.reduce((OuterComponent, InnerComponent) => ({ children }) => (
    <OuterComponent>
      <InnerComponent>{children}</InnerComponent>
    </OuterComponent>
  ))
